"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtArrowRight = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtArrowRight = function SvgBtArrowRight(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1644 9.07214C14.9273 8.80786 14.9493 8.40142 15.2136 8.16434C15.4779 7.92726 15.8843 7.9493 16.1214 8.21358L20.4785 13.0705C20.6501 13.2618 20.686 13.5276 20.5924 13.7498C20.6907 13.9829 20.6454 14.2623 20.4561 14.4528L16.0995 18.8388C15.8493 19.0907 15.4423 19.092 15.1904 18.8418C14.9385 18.5916 14.9371 18.1846 15.1873 17.9327L19.3519 13.7401L15.1644 9.07214Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.155 13.7451L8 13.7451",
    stroke: "currentColor",
    strokeWidth: 1.29,
    strokeLinecap: "round"
  }));
};

exports.SvgBtArrowRight = SvgBtArrowRight;